import React from 'react';
import useModuleStatus from '../../hooks/useModuleStatus';

interface FeatureGuardProps {
  moduleId: string;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  checkFor?: 'route' | 'module';
}

/**
 * Declares UI availability based on subscription features.
 */
const ModuleGuard: React.FC<FeatureGuardProps> = ({
  moduleId,
  children,
  fallback = null,
  checkFor = 'module',
}) => {
  const { isEnabled } = useModuleStatus();

  if (!isEnabled(moduleId, checkFor)) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default ModuleGuard;
